import React from 'react';

/* --- import Components ----*/
import { TypicalDay } from 'src/components/Bootcamp/Schedule/TypicalDay';
import { TypicalWeek } from 'src/components/Bootcamp/TypicalWeek';
import { Program, ProgramHeader } from 'src/components/Bootcamp/Schedule/Program';

const Schedule = React.memo(
  ({
    course,
    headerDescription,
    bootcampType,
    formSuccess,
    setFormSuccess,
    values,
    setValues,
    isModalFormOpen,
    setIsModalFormOpen,
    children,
  }) => {
    return (
      <div>
        <ProgramHeader headerDescription={headerDescription ? headerDescription : children} />
        {course === 'rncp6-fullTime' ? (
          <TypicalDay id="typical-day" />
        ) : course === 'rncp6-partTime' ? (
          <TypicalWeek id="typical-week" />
        ) : null}
        <Program
          course={course}
          id="program"
          isModalFormOpen={isModalFormOpen}
          setIsModalFormOpen={setIsModalFormOpen}
          bootcampType={bootcampType}
          formSuccess={formSuccess}
          setFormSuccess={setFormSuccess}
          values={values}
          setValues={setValues}
        />
      </div>
    );
  }
);
export default Schedule;
